import * as ViewerCache from '../utils/ViewerCache';
export const configureViewerCacheMiddleware = actionType => () => next => action => {
  if (action.type === actionType) {
    var _payload;
    const payload = typeof ((_payload = action.payload) === null || _payload === void 0 ? void 0 : _payload.toJS) === 'function' ? action.payload.toJS() : action.payload;
    ViewerCache.set(payload);
  }
  return next(action);
};